import { Inject, Vue } from "vue-facing-decorator";

export function defaultStopProcessUpdate(a: any) {
  const catalyst = window["Catalyst"];
  if (catalyst) {
    if (catalyst.debug) {
      console.debug(
        "Using default implementation for function the stopProcessUpdate. Setting Catalyst.processing=false. Caller: %s",
        a
      );
    }
    catalyst.processing = false;
  } else {
    console.warn(
      "The function stopProcessUpdate is not defined but referenced in: %s",
      a
    );
  }
}

export class ProcessUpdateMixin extends Vue {
  @Inject({
    from: "stopProcessUpdate",
    default: () => defaultStopProcessUpdate
  })
  readonly stopProcessUpdate!: Function;
}
